// extracted by css-extract-rspack-plugin
export default {"topLevelControls":"gPEaDFxTeYrr_1at"};